import { ICommonSettings, IFrontendUrlSetting } from "@kuika/kuika-cl-model";
import { Form } from "antd/es";
import { RuleObject } from "antd/es/form";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigFrontendUrlSettings } from "./app-settings-connfig-frontend-url";

export interface IConfigFrontendUrlInputState {
  showModal: boolean;
  editingFrontendUrlId: string;
}

export interface IConfigFrontendUrlInputProps {
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigFrontendUrlInput extends PureComponent<IConfigFrontendUrlInputProps, IConfigFrontendUrlInputState> {
  formInputName = ["webConfig", "frontendUrlSettingsId"];

  constructor(props: IConfigFrontendUrlInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingFrontendUrlId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingFrontendUrlId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingFrontendUrlId: id, showModal: true });
  };

  render() {
    const options = [
      { id: null, name: "Default" } as unknown as IFrontendUrlSetting,
      ...(this.props.commonSettings.frontendUrlSettings || [])
    ];
    return (
      <>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => prevValues.isKuikaCloud !== currentValues.isKuikaCloud}
        >
          {({ getFieldValue }) => {
            const isKuikaCloud = getFieldValue("isKuikaCloud");
            return (
              <ConfigFrontendUrlSettings
                formInputName={this.formInputName}
                closeModal={this.closeModal}
                showModal={this.state.showModal}
                editingFrontendUrlId={this.state.editingFrontendUrlId}
                commonSettings={this.props.commonSettings}
                isKuikaCloud={isKuikaCloud}
                getSectionDescription={this.props.getSectionDescription}
                handleCreateCommonConfig={this.props.handleCreateCommonConfig}
                handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
                handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
              />
            );
          }}
        </Form.Item>
        <div style={{ marginTop: 16 }}>
          <ConfigSettingSelect
            label="Frontend Url"
            // A Kuika Cloud deployment has nowhere to reach the app without this, so the
            // form refuses to save while the switch is on and the field is empty. It reads
            // the switch through `getFieldValue` because `isKuikaCloud` is a root-level key
            // with no `Form.Item` of its own, and names it in `dependencies` so antd
            // re-runs the rule when the switch moves rather than only when this field does.
            dependencies={["isKuikaCloud"]}
            rules={[
              ({ getFieldValue }) => ({
                validator(_rule: RuleObject, value: string | null): Promise<void> {
                  const isKuikaCloud: boolean = getFieldValue("isKuikaCloud");
                  if (isKuikaCloud && !value) {
                    return Promise.reject(new Error("Frontend URL is required when Kuika Cloud is enabled"));
                  }
                  return Promise.resolve();
                }
              })
            ]}
            formInputName={this.formInputName}
            options={options}
            tooltipContentKey="web_hostsettings_frontendurl(opt.)"
            onAddNew={this.openModal}
            onEdit={this.setEditingSetting}
            dropdownTestId="hostSettingsFrontendUrlDropdown"
            addNewTestId="hostSettingsFrontendUrlAddNewButton"
            editTestId="editFrontendUrlSettingButton"
          />
        </div>
      </>
    );
  }
}
